import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Typography, Grid, Button } from '@material-ui/core'
import { useStyles } from './style';

interface Props {
    showScreenLoader?: boolean;
  }

export const NotFoundSearch: FC<Props> = (p) => {
    const classes = useStyles();

    return (
        <div className={classes.mainContainer} hidden={p.showScreenLoader}>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{padding: '100px 0px'}}
            >
                <Grid item sm={12} md={5}>
                    <Typography variant="h1" component="h1" className={classes.errorCode}>
                        404
                    </Typography>
                </Grid>
                <div className={classes.verticalDivider}></div>
                <Grid item sm={12} md={5} className={classes.informationContainer}>
                    <p style={{fontWeight:'bolder'}}>
                    No se encontraron resultados
                    </p>
                    <p style={{fontWeight:'lighter'}}>
                        Lamentamos el inconveniente. Parece ser que estás accediendo a una página que no existe.
                    </p>
                </Grid>
                <Grid item sm={12} md={12} className={classes.homeContainer}>
                    <Button component={Link} to="/" variant="contained" className={classes.homeButton}>
                        Ir a inicio
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
}
